// forecastSlice.js
import { createSlice } from "@reduxjs/toolkit";

const getforecastEmailSlice = createSlice({
  name: "forecast",
  initialState: {
    latestCpsDate: null,
    latestDpsDate: null,
  },
  reducers: {
    setForecastUpdates: (state, action) => {
      state.latestCpsDate = action.payload.latestCpsDate;
      state.latestDpsDate = action.payload.latestDpsDate;
    },
  },
});

export const { setForecastUpdates } = getforecastEmailSlice.actions;
export default getforecastEmailSlice.reducer;
